import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../../components/css/transfer.css';
import internationalTransfersImages from "../../assets/static/77.png";

function OpenNewAccount() {
  return (
    <div>
    <Container fluid className="my-5 bg-custom">
      <Container className='container-padding'>
        <Row className="flex-column flex-md-row">
    {/* Image column - appears on top on mobile, right on desktop */}
    <Col md={6} className="order-1 order-md-2">
      <img
        src={internationalTransfersImages}
        alt="International Features"
        className="img-fluid" 
        style={{ maxWidth: '90%' }}

      />
    </Col>

    {/* Text column - appears below image on mobile, left on desktop */}
    <Col md={6} className="d-flex align-items-center order-2 order-md-1">
      <div>
      <h2>Open An Account Online</h2>
      <h1>Opening your Kontriman account has never been easier!</h1>
        <p>
        Whether you're at home or on the go, you can open your account in just minutes — online or through our mobile app. Enjoy a seamless, secure, and paperless experience. Start your financial journey with convenience at your fingertips!
        </p>
        <br></br>
        <a href="/bank_transfer">
          <Button className='custom-button'>Discover More on Kontriman Acounts</Button>
        </a>
      </div>
    </Col>
  </Row>
      </Container>
    </Container>
    </div>
  );
}

export default OpenNewAccount;
